import { render, staticRenderFns } from "./Iframe.vue?vue&type=template&id=3a734830&scoped=true"
import script from "./Iframe.vue?vue&type=script&lang=ts"
export * from "./Iframe.vue?vue&type=script&lang=ts"
import style0 from "./Iframe.vue?vue&type=style&index=0&id=3a734830&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a734830",
  null
  
)

export default component.exports